import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { QcRequestsPage } from "@/features/quality/components/requests/qc-requests-page";

const search = z.object({
  tab: z.enum(["open", "cancelled"]).default("open"),
  q: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  // The finished tab's page; the live tabs scroll.
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/quality/requests/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <QcRequestsPage
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
